//Libraries
import { Box, Grid, Typography } from "@mui/material";

// Layouts
import LabeledFormInput from "@/Layouts/components/SmartAddressFormSection/LabeledFormInput";
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";

// Context
import { useLeadsContext } from "@/DataPages/context/crm/LeadsContext";

// Constants
import { REQUIRED_FIELD_CLASSES } from "../../../constants";
import useVehicleOptions from "../../../hooks/useVehicleOptions";
import { sortDropdownOptions } from "../../../helpers";
import { TType } from "../../../types";

export default function TradeVehicleSection() {
	const { isSavingLead, getContextValue, getContextError, onChangeContext } = useLeadsContext();

	const {
		make: { data: makeOptions = [], isLoading: isLoadingMakeOptions },
		model: { data: modelOptions = [], isLoading: isLoadingModelOptions },
		year: { data: yearOptions = [], isLoading: isLoadingYearsOptions },
	} = useVehicleOptions(getContextValue("vehicle", "make"), getContextValue("vehicle", "model"));

	function cleanModel() {
		onChangeContext("vehicle", "model", "");
		cleanYear();
	}

	function cleanYear() {
		onChangeContext("vehicle", "year", "");
	}

	return (
		<Box>
			<Typography className="!font-montserrat !font-[500] !text-[16px] !text-gray-text !mb-3">Trade Vehicle</Typography>

			<Grid container rowSpacing={1.5} spacing={3} className="!mb-3">
				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label="VIN"
						formInput={
							<SimpleTextField
								inputProps={{ maxLength: 17, className: "uppercase" }}
								editable
								outlined
								text={getContextValue("vehicle", "vin")}
								placeholder={"VIN"}
								onFocusOut={(value = "") => onChangeContext("vehicle", "vin", value)}
								error={getContextError("vehicle", "vin")}
								classes={getContextError("vehicle", "vin") ? REQUIRED_FIELD_CLASSES : ""}
								disabled={isSavingLead}
							/>
						}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label="Year"
						formInput={
							<SmartSelector
								selectBy={"type"}
								showBy={"type"}
								options={yearOptions}
								selected={getContextValue("vehicle", "year")}
								popperProps={{ sx: { zIndex: `${1300}!important` } }}
								onChangeAction={(value) => onChangeContext("vehicle", "year", (value as unknown as TType)?.type ?? "")}
								inputProps={{
									placeholder: "Year",
								}}
								clearable
								loading={isLoadingYearsOptions}
								disabled={isSavingLead}
							/>
						}
					/>
				</Grid>
			</Grid>

			<Grid container rowSpacing={1.5} spacing={3} className="!mb-3">
				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label="Make"
						formInput={
							<SmartSelector
								selectBy={"type"}
								showBy={"type"}
								options={sortDropdownOptions(makeOptions)}
								selected={getContextValue("vehicle", "make")}
								popperProps={{ sx: { zIndex: `${1300}!important` } }}
								onChangeAction={(value) => {
									onChangeContext("vehicle", "make", (value as unknown as TType)?.type ?? "");
									cleanModel();
								}}
								inputProps={{
									placeholder: "Make",
								}}
								clearable
								loading={isLoadingMakeOptions}
								disabled={isSavingLead}
							/>
						}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label="Model"
						formInput={
							<SmartSelector
								selectBy={"type"}
								showBy={"type"}
								options={sortDropdownOptions(modelOptions)}
								selected={getContextValue("vehicle", "model")}
								popperProps={{ sx: { zIndex: `${1300}!important` } }}
								onChangeAction={(value) => {
									onChangeContext("vehicle", "model", (value as unknown as TType)?.type ?? "");
									cleanYear();
								}}
								inputProps={{
									placeholder: "Model",
								}}
								clearable
								loading={isLoadingModelOptions}
								disabled={isSavingLead}
							/>
						}
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<LabeledFormInput
						label="Odometer"
						formInput={
							<SimpleTextField
								onlyNumbers
								editable
								outlined
								text={getContextValue("vehicle", "odometer")}
								placeholder={"Odometer"}
								onFocusOut={(value = "") => onChangeContext("vehicle", "odometer", value)}
								disabled={isSavingLead}
								inputProps={{ maxLength: 10 }}
							/>
						}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
